import { fieldServiceTypeOptions } from "@/common/const/filter-options";
import fieldServiceHoursOptions from "@/common/const/filter-options/fieldServiceHours.options";
import { ResponseFormElementsType } from "@/common/types/forms/FormFieldsStrategy.type";

const fieldServiceResStrategy: ResponseFormElementsType[] = [
  {
    type: "select",
    attribute: "fieldServiceType",

    required: true,
    options: fieldServiceTypeOptions,
  },
  {
    type: "select",
    attribute: "hoursType",
    required: true,

    options: fieldServiceHoursOptions,
  },
  {
    type: "text",
    attribute: "leadTeam",
    required: true,

    inputClassElement: "border-gray-surface bg-white",
    pattern: /^\d{1,3}$/,
    patternMessage: "Lead time must be a number (days)",
  },
  {
    type: "text",
    attribute: "noOfHours",
    required: true,

    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(1[0-9]|[1-9])$/, 
    patternMessage: "Number of hours must be between 1 and 24",
  },
];
export default fieldServiceResStrategy;
